import { TranslateService } from '@ngx-translate/core';
//import { Observable } from 'rxjs/Observable';

import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import { ItemAction } from 'app/buffer-graph/models/item-actions/item-action';
import { FreshItemActionHeader } from 'app/buffer-graph/models/item-actions/fresh-item-action-header';

type Action = ItemAction | FreshItemActionHeader;
type Data = { actions: Action[], isFresh: boolean, sku: string, warehouseCode: string, canSend: boolean, isAll?: boolean };

export class ItemActionsTabInfo extends TabInfoBase<Data> {
    constructor(data: Data) {
        super('Actions', data);
    }

    get id(): string {
        return ItemActionsTabInfo.id;
    }

    static readonly id = 'IA';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-actions/item-actions-tab-info.ts